import React from 'react';

import { Container } from './styles';

export const MainColumn = (props) => {
    return <Container>{props.children}</Container>;
};
